import React, { useEffect, useState } from 'react';
import { globals } from '../../misc/globals';
import { BaseConfig } from '../BaseConfig';
import { UIProperties } from '../UIProperties';

import './GeneralButtonWithText.css'

const GeneralButtonWithText = (props: UIProperties<GeneralButtonWithTextConfig>) => {
	const [isOver, setIsOver] = useState(false);
	useEffect(() => {

	}, [isOver])

	return (
		<div className='modal-disable-select' style={{
			position: 'absolute',
			top: props.parameters.top,
			left: props.parameters.left,
			width: props.parameters.srcIdle && props.parameters.srcHighlight ? props.parameters.width : 'auto'
		}}>
			<button tabIndex={props.parameters.isNotTabbable ? -1 : 0} id={props.parameters.id} aria-label={props.parameters.ariaLbl ?? props.parameters.text}  className="pointer" style={{
				position: 'relative',
				background: 'transparent',
				pointerEvents: props.parameters.isDisabled ? 'none' : 'all',
				width: '100%',
				...props.parameters.customBttnStyle
			}} onMouseOver={() => {
                if(props.parameters.highlightOnHover) {
                    setIsOver(true);
                }
			}} 
			onMouseEnter={() => {
				var rollOverAudio = document.getElementById('button-rollover');
				if(!globals.isMuted) {
					(rollOverAudio as any).play();
				}
			}}
			aria-disabled={props.parameters.isDisabled}
			onMouseDown={() => {
				setIsOver(true);
			}} onMouseUp={() => {
				setIsOver(false);
			}} onMouseOut={() => {
				setIsOver(false);
			}} onClick={() => {
				if(props.parameters.isDisabled) {
					return;
				}
				var clickAudio = document.getElementById('button-click');
				if(!globals.isMuted) {
					(clickAudio as any).play();
				}
				console.log('clicked')
				if(props.parameters.onClicked) {
					props.parameters.onClicked();
				}
			}} onKeyUp={props.parameters.onKeyUp}>
				<img style={{
					pointerEvents: 'none',
					position: 'relative',
					filter: props.parameters.isDisabled ? 'brightness(50%)' : 'brightness(100%)',
					...props.parameters.customImgStyle
				}} src={props.parameters.srcIdle ? props.parameters.srcIdle :"./assets/images/general/buttons/button_main.png"} />
				
				{isOver || props.parameters.shouldLeaveOn ? (<img style={{
					position: 'absolute',
					top: '0',
					left: '0',
					height: '100%',
					pointerEvents: 'none',
					...props.parameters.customImgStyle
				}} src={props.parameters.srcHighlight ? props.parameters.srcHighlight : "./assets/images/general/buttons/button_hover.png"}  />) : (<div></div>)}
				{props.parameters.isDisabled ? (<img style={{
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    width: '100%',
                    height: '100%',
                    pointerEvents: 'none',
					...props.parameters.customImgStyle
                }} src={props.parameters.srcDisabled} />) : (<div></div>)}
				<p className="title-font" style={{
					position: 'absolute',
					margin: '0',
					left: '50%',
					top: '50%',
					transform: 'translate(-50%, -50%)',
					width: '100%',
					color: 'white',
					textShadow: '1px 3px 1px black',
					filter: props.parameters.isDisabled ? 'brightness(50%)' : 'brightness(100%)',
					...props.parameters.customTextStyle
				}}>{props.parameters.text}</p>
			</button>
		</div>
	);

};

export interface GeneralButtonWithTextConfig extends BaseConfig{
	top: string;
	left: string;
    isDisabled?: boolean;
	srcDisabled?: string;
	srcIdle?: string;
    srcHighlight?: string;
	highlightOnHover?: boolean;
	ariaLbl?: string;
	id?: string;
	isNotTabbable?: boolean;
	text: string;
	width: string;
	shouldLeaveOn?: boolean;
	customBttnStyle?: any;
	customImgStyle?: any;
	customTextStyle?: any;
	onClicked: () => void;
	onKeyUp?: (e: any) => void;
}

export default GeneralButtonWithText;